export type NutritionFactsGroupType = {
  name: string
  entries: Array<{
    id: string
    name: string
    unit: string
  }>
  showHeading?: boolean
  expandable?: boolean
}

const nutritionFactsList: NutritionFactsGroupType[] = [
  {
    name: 'Macro',
    showHeading: false,
    entries: [
      {
        id: 'carbohydrate',
        name: 'Carbohydrates',
        unit: 'g',
      },
      {
        id: 'protein',
        name: 'Proteins',
        unit: 'g',
      },
      {
        id: 'fat',
        name: 'Lipids',
        unit: 'g',
      },
    ],
  },
  {
    name: 'Micro',
    entries: [
      {
        id: 'alcohol',
        name: 'Alcohol',
        unit: 'g',
      },
      {
        id: 'fiber',
        name: 'Fiber',
        unit: 'g',
      },
      {
        id: 'cholesterol',
        name: 'Cholesterol',
        unit: 'mg',
      },
      {
        id: 'salt',
        name: 'Salt',
        unit: 'g',
      },
      {
        id: 'starch',
        name: 'Starch',
        unit: 'g',
      },
      {
        id: 'sugar',
        name: 'Sugar',
        unit: 'g',
      },
      {
        id: 'water',
        name: 'Water',
        unit: 'g',
      },
    ],
  },
  {
    name: 'Fatty acids',
    expandable: true,
    entries: [
      {
        id: 'saturatedFattyAcids',
        name: 'Saturated',
        unit: 'mg',
      },
      {
        id: 'monoUnsaturatedFattyAcids',
        name: 'Monounsaturated',
        unit: 'mg',
      },
      {
        id: 'polyUnsaturatedFattyAcids',
        name: 'Polyunsaturated',
        unit: 'mg',
      },
      {
        id: 'transFattyAcids',
        name: 'Trans',
        unit: 'mg',
      },
    ],
  },
  {
    name: 'Vitamins',
    expandable: true,
    entries: [
      {
        id: 'vitaminA',
        name: 'Vitamin A',
        unit: 'mg',
      },
      {
        id: 'vitaminB6',
        name: 'Vitamin B6',
        unit: 'mg',
      },
      {
        id: 'vitaminB12',
        name: 'Vitamin B12',
        unit: 'mg',
      },
      {
        id: 'vitaminC',
        name: 'Vitamin C',
        unit: 'mg',
      },
      {
        id: 'vitaminD',
        name: 'Vitamin D',
        unit: 'mg',
      },
      {
        id: 'vitaminE',
        name: 'Vitamin E',
        unit: 'mg',
      },
      {
        id: 'folate',
        name: 'Folate',
        unit: 'mg',
      },
      {
        id: 'niacin',
        name: 'Niacin',
        unit: 'mg',
      },
      {
        id: 'riboFlavin',
        name: 'Riboflavin',
        unit: 'mg',
      },
      {
        id: 'thiamin',
        name: 'Thiamin',
        unit: 'mg',
      },
    ],
  },
  {
    name: 'Minerals',
    expandable: true,
    entries: [
      {
        id: 'calcium',
        name: 'Calcium',
        unit: 'mg',
      },
      {
        id: 'iron',
        name: 'Iron',
        unit: 'mg',
      },
      {
        id: 'magnesium',
        name: 'Magnesium',
        unit: 'mg',
      },
      {
        id: 'phosphorus',
        name: 'Phosphorus',
        unit: 'mg',
      },
      {
        id: 'potassium',
        name: 'Potassium',
        unit: 'mg',
      },
      {
        id: 'sodium',
        name: 'Sodium',
        unit: 'mg',
      },
      {
        id: 'zinc',
        name: 'Zinc',
        unit: 'mg',
      },
    ],
  },
]

export default nutritionFactsList
